import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import MyButton from '../../../utils/MyButton'
import { FaArrowCircleLeft, FaChartBar } from 'react-icons/fa'

import './Infraestructura.css'

import TablaAreas from './TablaAreas'

export class Infraestructura extends Component {
  render() {
    const { clienteId } = this.props.match.params;
    const { tipouser } = this.props.user.credentials;
    
    // Determina la ruta según el tipo de usuario
    const volverLink =
      tipouser === 'Ingeniero'
        ? `/dashboard/perfilcliente/${clienteId}`
        : `/dashboard/perfilclientetec/${clienteId}`;

    return (
      <div>
        <div className="titulo_section">
          <div className="titulo_clientes">
            <h1 className="text-clientes">Infraestructura</h1>
            <hr className="clientes_separator" />
          </div>

          <div className="div_boton">
            <Link to={volverLink}>
              <MyButton tip="Volver">
                <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente" />
              </MyButton>
            </Link>
          </div>
        </div>

        <div className="container-inventario-perfil">
          <div className="div-tabla-equipos">
            <TablaAreas clienteId={clienteId} />
          </div>
        </div>
      </div>
    )
  }
}

Infraestructura.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(Infraestructura);